<template>
  <OfferViewPC v-if="isMobile === 'PC'" />
  <OfferViewH5 v-if="isMobile === 'MOBILE'" />
</template>

<script setup>
import OfferViewPC from './components/OfferViewPC/index.vue'
import OfferViewH5 from './components/OfferViewH5/index.vue'
import { metaPixelTrack } from '@/utils/utils'

const route = useRoute()

onBeforeMount(() => {
  /**
   * Meta Pixel 埋点：查看非Featured商品详情
   */
  if (route.query.from !== 'featured') {
    metaPixelTrack('PPD101', 'ViewContent', {
      content_ids: [route.params.id],
      content_type: 'product',
      currency: '$',
      value: 0.2
    })
  }
})

const isMobile = ref(false)
onBeforeMount(async () => {
  const userAgent = navigator.userAgent.toLowerCase()
  isMobile.value = /iphone|ipod|ipad|android|blackberry|windows phone/i.test(userAgent) ? 'MOBILE' : 'PC'
})

</script>
